window.__VROCS_EARLY_ERRORS = window.__VROCS_EARLY_ERRORS || [];

function captureClientError(report) {
  if (window.VROCS_ERROR_REPORTER?.capture) {
    window.VROCS_ERROR_REPORTER.capture(report);
    return;
  }
  if (window.__VROCS_EARLY_ERRORS.length < 8) window.__VROCS_EARLY_ERRORS.push(report);
}

window.addEventListener("error", (event) => {
  const resource = event.target && event.target !== window ? event.target : null;
  if (resource) {
    const source = resource.currentSrc || resource.src || resource.href || resource.tagName || "resource";
    captureClientError({ errorType: "resource", message: `Resource failed to load: ${source}` });
    return;
  }
  captureClientError({
    errorType: "runtime",
    message: event.message || event.error?.message || "Runtime error",
    stack: event.error?.stack || "",
    metadata: { line: event.lineno || null, column: event.colno || null }
  });
}, true);

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  captureClientError({
    errorType: "promise",
    message: reason?.message || String(reason || "Unhandled promise rejection"),
    stack: reason?.stack || ""
  });
});

await import("./runtime-config.js");
await import("./platform.js");
await import("./pwa.js");

function loadClassicScript(source) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = source;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`Failed to load ${source}`));
    document.head.append(script);
  });
}

if (!window.maplibregl) {
  const mapLibreSource = new URL("../vendor/maplibre/maplibre-gl.js", import.meta.url).href;
  loadClassicScript(mapLibreSource)
    .then(() => window.dispatchEvent(new CustomEvent("vrocs:maplibre-ready")))
    .catch(() => window.dispatchEvent(new CustomEvent("vrocs:maplibre-unavailable")));
}

await import("./place-taxonomy.js");
await import("./data.js");
await import("./localization.js");
await import("./api.js");
const { startClientErrorReporting } = await import("./error-reporting.js");
startClientErrorReporting();
await import("./app.js");
